import React from 'react';
import { useTranslation } from 'react-i18next';
import {
    PREMIUM_PLUS_SUBSCRIPTION_MONTHLY_PRICE,
    PREMIUM_PLUS_SUBSCRIPTION_MONTHLY_PRICE_WITH_VAT,
    PREMIUM_PLUS_SUBSCRIPTION_YEARLY_PRICE,
    PREMIUM_PLUS_SUBSCRIPTION_YEARLY_PRICE_WITH_VAT,
} from '@app/common';

type TariffPremiumPlusProps = {
    period: 'yearly' | 'monthly';
};

export const TariffPremiumPlusPrice: React.FC<TariffPremiumPlusProps> = ({ period }) => {
    const { t } = useTranslation();

    return (
        <div className="flex w-full flex-col flex-wrap items-baseline text-[3.2rem] leading-[3.2rem] font-bold">
            <div>
                <span className="inline-flex items-end max-[599px]:basis-full">
                    {period === 'monthly'
                        ? PREMIUM_PLUS_SUBSCRIPTION_MONTHLY_PRICE
                        : PREMIUM_PLUS_SUBSCRIPTION_YEARLY_PRICE}
                </span>

                <span className="inline-flex items-end text-xlarge text-[var(--tariff-color-darken)]">
                    &nbsp;{t(`blocks.pricing.common.withoutVat`)}&nbsp;/ {t(`blocks.pricing.common.yearly`)}
                </span>
            </div>
            <div className="text-xlarge text-[var(--tariff-color-darken)]">
                <span className="inline-flex items-end max-[599px]:basis-full">
                    {period === 'monthly'
                        ? PREMIUM_PLUS_SUBSCRIPTION_MONTHLY_PRICE_WITH_VAT
                        : PREMIUM_PLUS_SUBSCRIPTION_YEARLY_PRICE_WITH_VAT}
                </span>
                <span className="inline-flex items-end text-xlarge text-[var(--tariff-color-darken)]">
                    &nbsp;{t(`blocks.pricing.common.withVat`)}&nbsp;/ {t(`blocks.pricing.common.yearly`)}
                </span>
            </div>
        </div>
    );
};
